const isRange = (value) => !!value && typeof value !== 'number' && typeof value === 'object';

export { isRange };
//# sourceMappingURL=isRange.js.map
